import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {LinksData, LinksDataQueryResponse} from './_models'
import { Company } from '../../../company/company-list/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const LINK_URL = `${API_URL}/webscrapping/generateLinks?websiteUrl=`
const FETCH_CONTENT_URL = `${API_URL}/webscrapping/fetchContent?websiteUrl=`
const FETCH_PDF_URL = `${API_URL}/webscrapping/fetchpdfcontent`
const GENERATE_FILE = `${API_URL}/embeddings`

const fetchLinks = (query: string): Promise<LinksDataQueryResponse> => {
  return axios
  .get(`${LINK_URL}`+ query)
  .then((d: AxiosResponse<LinksDataQueryResponse>) => d.data)
}



const fetchContentWebsite = (query: any): Promise<any> => {
  return axios
  .get(`${FETCH_CONTENT_URL}`+ query)
  .then((d: AxiosResponse<any>) => d.data)
}




const writeTextFile = (fileData: any): Promise<any | undefined> => {
  return axios
    .post(`${GENERATE_FILE}/embeddingviatxt`, fileData)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response.data)
}


const fetchPdfFileContent = (fileData: any): Promise<any | undefined> => {
  return axios
    .post(`${FETCH_PDF_URL}`, fileData)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response.data)
}




export {fetchLinks, fetchContentWebsite,writeTextFile,fetchPdfFileContent}
